import { OrderItemViewType } from 'types/orderitemviewtype';

export type OrderItemStatus = {
  label: string;
  color: 'primary' | 'secondary' | 'error' | 'success' | 'warning' | 'default';
  id: string;
  orderItemViewType: OrderItemViewType;
};

export const statusChips: Record<string, OrderItemStatus> = {
  Cancelled: {
    label: 'Cancelled',
    color: 'warning',
    id: '4a7b067b-4e0d-4bce-9a62-1d1a3a4e5c24',
    orderItemViewType: OrderItemViewType.Historic
  },
  Complete: {
    label: 'Complete',
    color: 'success',
    id: 'a17f3cb6-7e64-49c3-8f8e-11258d216b1e',
    orderItemViewType: OrderItemViewType.Historic
  },
  New: { label: 'New', color: 'success', id: 'af6c5daf-1c3c-4e4f-9c4c-6d7d8a8c1caf', orderItemViewType: OrderItemViewType.Active },
  'In progress': {
    label: 'In-Progress',
    color: 'primary',
    id: 'db88a23c-5b1d-4c0f-98f3-04583e5a4b14',
    orderItemViewType: OrderItemViewType.Active
  },
  'On hold': {
    label: 'On Hold',
    color: 'default',
    id: '9c0bfa6c-3b45-490f-9430-7de258d2b9b0',
    orderItemViewType: OrderItemViewType.OnHold
  },
  QC: { label: 'QC', color: 'warning', id: '8283cf66-25da-49b4-925b-baa6e4b9e557', orderItemViewType: OrderItemViewType.Active },
  'QC fail': { label: 'QC Fail', color: 'error', id: 'feccdcf7-c4af-4d61-bd04-a69e33c0b13b', orderItemViewType: OrderItemViewType.Active }
};
